import { Context } from '@nuxt/types'
import { HTTP_REST_FRONTEND_API } from '../plugins/axiosFrontendApi'
import { ThemeType } from '../contracts/Settings'
import { PageHideNavigation } from '../contracts/Page'
import { searchVacanciesRequest } from './searchVacanciesRequest'
import { Logger } from './Logger'

export const pageRequest = async (ctx: Context) => {
  const {
    app,
    route: { path, query },
    error,
    redirect,
    store: { dispatch, commit },
    $config,
  } = ctx
  // формируем урл для запрос данных страницы с frontend api
  const reqUrl = $config.SM_API_GET_PAGE_STATE_PATH + path
  try {
    // запрос на frontend api
    const res = await HTTP_REST_FRONTEND_API(ctx).get(reqUrl)
    const content = res.data

    if (content.redirect && content.redirect.length) {
      return redirect(301, content.redirect)
    }

    if (content.error) {
      error({ statusCode: 404 }) // если есть ошибка выкидываем 404
      // уведомление страницы
      commit('settings/SET_NOTIFICATION', undefined)
    } else {
      // данные полученные с frontend api
      let setThemeOnClient = false
      const {
        breadcrumbs,
        isSearchVacanciesPage,
        showButtonBuyOnline,
        components: pageComponents,
        theme = ThemeType.primary,
        notification,
        hideNavigation,
        hideBreadcrumbs,
      } = content

      if (process.server) {
        commit('settings/SET_THEME', theme)
      } else {
        setThemeOnClient = true
      }

      console.log(content, 'content')

      if (content.pageRoute) {
        const currentPage =
          content.pageRoute.find((page) => page.fullPath === path) ||
          content.pageRoute[0]

        // Преобразуем дату обновления текущей страницы
        const pageDate = new Date(currentPage.updatedAt)

        // Если в content.components есть updatedAt, пробежимся по ним и найдем самую новую дату
        let componentsDate = pageDate // по умолчанию берем дату страницы
        if (
          Array.isArray(content.components) &&
          content.components.length > 0
        ) {
          content.components.forEach((component: any) => {
            if (component.updatedAt) {
              const compDate = new Date(component.updatedAt)
              if (compDate > componentsDate) {
                componentsDate = compDate
              }
            }
          })
        }

        // Выбираем дату, которая ближе к текущей (то есть более новая)
        const finalUpdatedDate =
          componentsDate > pageDate ? componentsDate : pageDate

        // Передаем выбранную дату в состояние Vuex
        commit('settings/SET_UPDATED_TIME', finalUpdatedDate.toISOString())
      }

      // записываем данные для хлебных крошек
      dispatch('breadcrumbs/create', breadcrumbs || [])
      commit('breadcrumbs/SET_BREADCRUMBS_VISIBILITY', !hideBreadcrumbs)
      // показать или не показать сквозную кнопку покупки оналйн
      commit('popupBuyOnline/SET_SHOW_BUTTON', !!showButtonBuyOnline)

      // уведомление страницы
      commit('settings/SET_NOTIFICATION', notification)

      // если на сайт зашли с webview, то скрываем футер и хедер
      const isWebview = query.client === 'emp'
      commit('settings/SET_HIDE_FOOTER', isWebview)
      commit('settings/SET_HIDE_HEADER', isWebview)
      // Скрыть навигацию
      if (hideNavigation === PageHideNavigation.ALL) {
        commit('settings/SET_HIDE_FOOTER', true)
        commit('settings/SET_HIDE_HEADER', true)
      }

      if (hideNavigation === PageHideNavigation.FOOTER) {
        commit('settings/SET_HIDE_FOOTER', true)
      }

      if (hideNavigation === PageHideNavigation.HEADER) {
        commit('settings/SET_HIDE_HEADER', true)
      }

      // скрыть все компоненты на странице для определенного iframe блока
      const isIframeOnClearPage = pageComponents.find(
        (component) =>
          component.type === 'sectionIframe' && component.value.clearPage
      )
      if (isIframeOnClearPage) {
        commit('settings/SET_HIDE_FOOTER', true)
        commit('settings/SET_HIDE_HEADER', true)
        commit('settings/SET_HIDE_SURVEY_BTN', true)
      }

      // обработчик запроса поиска вакансий
      if (isSearchVacanciesPage) {
        try {
          const { components } = await searchVacanciesRequest(
            query,
            app,
            pageComponents
          )

          return { ...content, components }
        } catch (e) {
          Logger.error(e)
          return {
            ...content,
            theme,
            setThemeOnClient,
            components: pageComponents.map((component) => {
              if (
                [
                  'sectionSearchVacancies',
                  'sectionSearchVacanciesStartCareer',
                ].includes(component.type)
              ) {
                return {
                  ...component,
                  value: {
                    ...component.value,
                    initialListVacancies: [],
                    listRegions: [],
                    listSpecialties: [],
                    initialTotalCountVacancies: 0,
                    searchError: true,
                  },
                }
              }
              return component
            }),
          }
        }
      }
      return {
        ...content,
        theme,
        setThemeOnClient,
      }
    }
    // обработчик ошибки
  } catch (e) {
    error({ statusCode: e?.response?.status || 500 })
  }
}
